module.exports = __webpack_public_path__ + "img/985.bba6939d.png";